import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	stateConnection: null,
};

const connection = createSlice({
	name: 'connection',
	initialState,
	reducers: {
		updateWebStatus(state, action) {
			state.stateConnection = action.payload;
		},
	},
	extraReducers: () => {},
});

export const { updateWebStatus } = connection.actions;
export default connection.reducer;
